import { getAddressLine } from '@app/utils/getAddressLine';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Addresses } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  address: Addresses.Basic | Empty.Object;
  title: string;
  isLoading?: boolean;
}

interface DisplayAddress {
  address: string;
  city: string;
  company: string;
  country: string;
  state: Maybe<string>;
  zipCode: string;
}

export const AddressSummary = ({ address, title, isLoading = false }: Props) => {
  const { t } = useTranslation(['common']);

  const copy: DisplayAddress = {
    address: t('common:address'),
    city: t('common:city'),
    company: t('common:company'),
    country: t('common:country'),
    state: t('common:state'),
    zipCode: t('common:zip_code'),
  };

  const displayAddress: DisplayAddress = {
    address: getAddressLine(address.address1, address.address2),
    city: address.city,
    /* check if address.company is string should be removed after fixing https://centracommerce.atlassian.net/browse/SBFT-3172 */
    company: typeof address.company === 'string' ? address.company : '',
    country: address.countryName,
    state: address.stateName ?? address.state,
    zipCode: address.zipCode,
  };

  return (
    <div>
      <p className="mb-3 body-1">{title}</p>
      <div className="space-y-2">
        {Object.keys(copy).map(item => {
          const value = displayAddress[item as keyof DisplayAddress];
          const hasValue = isDefined(value) && !isEmpty(value);

          if (!hasValue && !isLoading) {
            return null;
          }

          return (
            <div className="flex gap-2" key={copy[item as keyof DisplayAddress]}>
              <dt className="text-neutral-60 body-1">{copy[item as keyof DisplayAddress]}:</dt>
              <dd className="body-1" data-sentry-mask>
                {displayAddress[item as keyof DisplayAddress]}
              </dd>
            </div>
          );
        })}
      </div>
    </div>
  );
};
